import { IPreciseLocation } from '~/client/graph'

import MapBoxViewerStore from './MapBoxViewer.store'

/**
 * Orientation and place, but NOT zoom: north-up is a different view of the world rather than a
 * wider one, so bearing and pitch have no default. Zoom does, and reaches a record only through
 * saveMapLocation — absent, never null, so a duplicate's JSON round-trip drops it.
 */
export function preciseLocationAtCoordinates(
  mapBoxViewerStore: MapBoxViewerStore,
  coordinates: { latitude: number; longitude: number },
): IPreciseLocation {
  const { bearing, pitch } = mapBoxViewerStore.viewport
  return {
    latitude: coordinates.latitude,
    longitude: coordinates.longitude,
    globeViewId: mapBoxViewerStore.selectedGlobe?.id,
    bearing,
    pitch,
  } as IPreciseLocation
}
